// src/pages/AdministrateLevels.js

import React, { useEffect, useState } from 'react';
import { fetchLevels, addLevel, updateLevel, deleteLevel } from '../services/dataFetch';

const AdministrateLevels = () => {
  const [levels, setLevels] = useState([]);
  const [form, setForm] = useState({ name: '' });
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [message, setMessage] = useState('');

  const loadLevels = async () => {
    try {
      const data = await fetchLevels();
      setLevels(data);
    } catch {
      setMessage('Failed to load levels');
    }
  };

  useEffect(() => {
    loadLevels();
  }, []);

  const handleInputChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleEditChange = (e) => setEditForm({ ...editForm, [e.target.name]: e.target.value });

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await addLevel(form);
      setForm({ name: '' });
      setMessage('Level added');
      loadLevels();
    } catch {
      setMessage('Error adding level');
    }
  };

  const handleUpdate = async (id) => {
    try {
      await updateLevel(id, editForm);
      setEditId(null);
      setMessage('Level updated');
      loadLevels();
    } catch {
      setMessage('Error updating level');
    }
  };

  const handleDelete = async (id) => {
    // Single confirmation
    if (!window.confirm('Are you sure you want to delete this level?')) {
      return;
    }

    try {
      // Always use force=true to delete level and its dependencies
      await deleteLevel(id, true);
      setMessage('Level deleted successfully!');
      loadLevels();
    } catch (err) {
      console.error(err);
      const errorMessage = err.message || 'Error deleting level';
      setMessage(errorMessage);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Administrate Levels</h2>

      <form onSubmit={handleAdd} style={{ marginBottom: '2rem' }}>
        <input
          name="name"
          placeholder="Level (e.g. A1)"
          value={form.name}
          onChange={handleInputChange}
          required
        />
        <button type="submit">Add Level</button>
      </form>

      {message && <p>{message}</p>}

      <table border="1" cellPadding="8" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Name</th>
            <th style={{ width: '160px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {levels.map((level) =>
            editId === level.id ? (
              <tr key={level.id}>
                <td>
                  <input
                    name="name"
                    value={editForm.name}
                    onChange={handleEditChange}
                  />
                </td>
                <td>
                  <button onClick={() => handleUpdate(level.id)}>Save</button>
                  <button onClick={() => setEditId(null)}>Cancel</button>
                </td>
              </tr>
            ) : (
              <tr key={level.id}>
                <td>{level.name}</td>
                <td>
                  <button onClick={() => { setEditId(level.id); setEditForm(level); }}>
                    Edit
                  </button>
                  <button onClick={() => handleDelete(level.id)}>Delete</button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdministrateLevels;
